import React, { useState } from 'react';
import { ArrowRight, Search } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  const [searchQuery, setSearchQuery] = useState('');
  return <section className="relative pt-10 pb-14 bg-white overflow-hidden" data-id="element-213">
      {/* Subtle animated gradient background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-214">
        <motion.div className="absolute -top-1/2 -left-1/4 w-[800px] h-[800px] rounded-full bg-gradient-to-r from-[#0052CC]/6 via-[#0052CC]/3 to-transparent blur-3xl" animate={{
        x: [0, 100, 0],
        y: [0, 50, 0],
        scale: [1, 1.1, 1]
      }} transition={{
        duration: 20,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-215" />
        <motion.div className="absolute -top-1/4 right-0 w-[600px] h-[600px] rounded-full bg-gradient-to-l from-slate-50 via-[#0052CC]/3 to-transparent blur-3xl" animate={{
        x: [0, -80, 0],
        y: [0, 80, 0],
        scale: [1, 1.15, 1]
      }} transition={{
        duration: 25,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 2
      }} data-id="element-216" />
      </div>

      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-8 relative" data-id="element-217">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center" data-id="element-218">
          {/* Left Content */}
          <div className="lg:pl-4" data-id="element-219">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} data-id="element-220">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-[#0A1628] leading-[1.08] mb-6" data-id="element-221">
                Industrial labels,
                <br data-id="element-222" />
                nameplates &
                <br data-id="element-223" />
                <span className="text-slate-400" data-id="element-224">safety signage</span>
              </h1>

              <p className="text-lg md:text-xl text-slate-500 mb-6 max-w-md leading-relaxed" data-id="element-225">
                Durable identification products for manufacturing, facilities,
                and industrial environments.
              </p>

              {/* Search Bar - Slightly more prominent */}
              <div className="mb-6 max-w-md" data-id="element-226">
                <div className="relative" data-id="element-227">
                  <Search className="absolute left-5 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" data-id="element-228" />
                  <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search labels, materials, sizes…" className="w-full pl-14 pr-5 py-4 bg-white border border-slate-200 rounded-xl text-base placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#0052CC]/15 focus:border-[#0052CC] transition-all shadow-sm" data-id="element-229" />
                </div>
              </div>

              {/* CTAs */}
              <div className="flex flex-wrap gap-3" data-id="element-230">
                <a href="/products" className="px-8 py-4 bg-[#0052CC] text-white font-bold rounded-full hover:bg-[#0040A0] transition-all duration-300 flex items-center group text-base shadow-lg shadow-[#0052CC]/20 hover:shadow-xl hover:shadow-[#0052CC]/25 hover:-translate-y-0.5" data-id="element-231">
                  Browse products
                  <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-232" />
                </a>
                <a href="/samples" className="px-6 py-4 bg-white border border-slate-200 text-[#0A1628] font-semibold rounded-full hover:border-[#0052CC] hover:text-[#0052CC] transition-all duration-300 text-base" data-id="element-233">
                  Request samples
                </a>
              </div>

              {/* Quick trust indicators */}
              <div className="mt-6 flex flex-wrap items-center gap-5 text-sm text-slate-500" data-id="element-234">
                <span className="flex items-center gap-2" data-id="element-235">
                  <span className="h-2 w-2 rounded-full bg-green-500" data-id="element-236"></span>
                  In stock & ready to ship
                </span>
                <span className="flex items-center gap-2" data-id="element-237">
                  <span className="w-1 h-1 bg-slate-300 rounded-full" data-id="element-238"></span>
                  ISO 9001 certified
                </span>
              </div>
            </motion.div>
          </div>

          {/* Right - Product image with more visual presence */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.98
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="relative group lg:-mr-8" data-id="element-239">
            <div className="relative aspect-[4/3] lg:aspect-[5/4]" data-id="element-240">
              <div className="absolute inset-0 rounded-2xl lg:rounded-l-2xl lg:rounded-r-none overflow-hidden bg-slate-100 shadow-2xl" data-id="element-241">
                <img src="https://cdn.magicpatterns.com/uploads/uH1CAGacPnUx7cXgA8uYKz/Nilpeter-FB-line.jpg" alt="Industrial label production" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-242" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}